<template>
  <div class="container-fluid index-page">
    <div class="row">
      <div class="col-md-12 col-sm-12">
        <div class="welcome-block">
          <div class="title">Hello!!</div>
          <div class="desc">歡迎回來iRecruit管理系統。</div>
          <img src="@/assets/img/index/工作區域 3.png" alt="" />
        </div>

        <div class="digital-list">
        </div>
      </div>
      <div class="col-md-12 col-sm-12"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      countDuration: 3000,
      InInterviewCount: 0,
      InterviewedCount: 0,
      InterviewResultCount: 0,
      AppointmentResultCount: 0,
    };
  },

  methods: {
    changeFile(currentSeeker) {
      this.currentFile = currentSeeker;
      this.detailCurrentPage = 0;
    },

    countFormat(value) {
      return `${Number(value).toFixed(0)}`;
    },
  },

  beforeRouteEnter(to, from, next) {
    next(() => {
      if (to !== from) {
        next();
      }
    });
  }
};
</script>

<style lang="scss" scoped>

@font-face {
  font-family: 'Oswald';
  src: url('~@/assets/fonts/Oswald-SemiBold.ttf') format('truetype');  
  font-style: normal;
}

.index-page {
  padding: 30px;
  padding-top: 40px;

  .welcome-block {
    background-color: #fff;
    padding: 20px;
    border-radius: 5px;
    margin-bottom: 10px;
    position: relative;

    .title {
      font-size: 2em;
      font-weight: bold;
      margin-bottom: 5px;
    }
    .desc {
      font-size: 0.9em;
      letter-spacing: 1px;
    }

    img {
      position: absolute;
      width: 145px;
      right: 15px;
      bottom: 0;
    }
  }
  .index-function-list {
    display: none;
    flex-wrap: wrap;

    .index-function-wrap {
      background-color: #fff;
      padding: 10px;
      border-radius: 5px;
      margin-bottom: 40px;
      width: 25%;
      border: 5px solid #f2f2f2;
      @media screen and (max-width: 768px) {
        width: 100%;
      }

      .function-info {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #f1f1f1;
        margin-bottom: 20px;
        padding-bottom: 10px;
        .img-wrap {
          img {
            width: 60px;
            transform: scale(1.5);
            transform-origin: bottom left;
          }
        }
        .text-wrap {
          margin-left: 35px;
          div {
            font-weight: bold;
            font-size: 0.9em;
          }
          span {
            font-size: 0.9em;
            opacity: 0.8;
            letter-spacing: 1px;
          }
        }
      }
      .function-items {
        display: flex;
        flex-wrap: wrap;
        a {
          margin: 5px;
          width: calc(50% - 10px);
          display: block;
          background-color: #5380f7;
          color: #fff;
          border-radius: 5px;
          padding: 30px;
          @media screen and (max-width: 768px) {
            width: 100%;
          }

          margin-bottom: 10px;
          text-align: center;
          box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.1);

          &:last-child {
            margin-right: 0;
          }

          div {
            margin-bottom: 10px;
            font-size: 0.9em;
            @media screen and (max-width: 768px) {
              display: inline-block;
              vertical-align: middle;
              margin-right: 15px;
            }
          }
          span {
            i {
              font-size: 2em;
              opacity: 0.3;
            }
          }
        }
      }
    }
  }

  .digital-list {
    display: flex;
    flex-wrap: wrap;
    margin-left: -10px;
    margin-right: -10px;
    .digital-wrap {
      width: 25%;
      padding: 10px;

      .inner {
        background-color: #fff;
        border-radius: 10px;
        text-align: center;
        padding: 60px 0;
        cursor: pointer;
        display: block;
        color: #383838;
        text-decoration: none;

        &:hover {
          img {
            transform: scale(1.2);
          }
        }

        img {
          width: 80px;
          transition: all 0.3s;
        }
        .name {
          opacity: 0.7;
        }
        .count {
          font-size: 3.5em;
          font-family: "Oswald", sans-serif;
        }
      }
      @media screen and (max-width: 767px) {
        width: 50%;
        .inner {
          padding: 30px 0;
          .name {
            margin-bottom: 10px;
          }
          .count {
            font-size: 1.7em;
          }
        }
      }
    }
  }
}

#seeker-detail-modal {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  padding: 30px;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;

  .close-detail {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }

  .seeker-list {
    height: 100%;
    overflow: auto;
    .seeker {
      color: #fff;
      display: flex;
      padding: 5px;
      align-items: center;
      cursor: pointer;
      margin-bottom: 5px;

      &.active {
        background-color: #5380f7;
        border-radius: 35px;
      }

      .img-wrap {
        margin-right: 10px;
        img {
          background-color: #fff;
          border-radius: 50%;
          width: 40px;
          padding: 5px;
        }
      }
      .info-wrap {
        flex: 1;
        padding-right: 10px;
        .job {
          opacity: 0.8;
          font-size: 0.8em;
        }
        .date {
          opacity: 0.8;
          font-size: 0.8em;
        }
      }
    }
  }
  .seeker-file {
    height: 100%;
    flex: 1;
    min-width: 1px;
    text-align: center;
    .file-tab {
      border: 2px solid #fff;
      display: inline-block;
      border-radius: 25px;
      padding: 5px;
      .tab {
        color: #fff;
        padding: 3px 10px;
        font-size: 0.9em;
        border-radius: 25px;

        &.active {
          background-color: #fff;
          color: #000;
        }
      }
    }
    .file {
      width: 100%;
      height: calc(100% - 50px);
      overflow-y: auto;
      padding: 20px;
      max-width: 680px;
      background-color: #fff;
      margin: 25px auto;
      box-shadow: -3px 3px 7px rgba(0, 0, 0, 0.3);
    }
  }
}
</style>
